import React from "react";
import { MenuIcon } from "@assets/svgIcons";

import "./index.scss";

const TopBar = ({ onMenuClick }) => {
  return (
    <div className="top-bar">
      <div className="topbar-left-section">
        {/* Mobile Menu Button */}
        <button className="menu-btn" onClick={onMenuClick}>
          <MenuIcon />
        </button>
      </div>
    </div>
  );
};

export default TopBar;
